import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import Countdown, { CountdownRendererFn } from "react-countdown";
import dayjs from "dayjs";

import { Expert, ExpertQueueItem } from "../../models/expert";

interface Props {
  expert: Expert;
  className?: string;
}

const ExpertBusyDuration: React.FC<Props> = ({ expert, className }) => {
  const { t } = useTranslation("expert");
  const [firstItem, setFirstItem] = useState<ExpertQueueItem>(
    expert?.queue?.items?.find((i) => i.type !== "BREAK" && i.startedAt !== null && i.metadata.maxDuration != null),
  );

  useEffect(() => {
    setFirstItem(expert?.queue?.items?.find((i) => i.type !== "BREAK" && i.startedAt !== null && i.metadata.maxDuration != null));
  }, [expert?.queue?.items]);

  const getEndDate = (item: ExpertQueueItem) => {
    if (!item?.startedAt === null || !item.metadata?.maxDuration) return undefined;
    return dayjs(firstItem.startedAt).add(firstItem.metadata.maxDuration, "second");
  };

  const renderCountDown: CountdownRendererFn = ({
    hours, minutes, seconds,
  }) => (
    <span className="font-semibold">
      {`${(hours).toLocaleString("fr-CH", { minimumIntegerDigits: 2 })}${t("common:hourLetter")} 
      ${minutes.toLocaleString("fr-CH", { minimumIntegerDigits: 2 })}${t("common:minuteLetter")} 
      ${seconds.toLocaleString("fr-CH", { minimumIntegerDigits: 2 })}${t("common:secondLetter")}`}
    </span>
  );

  if (!firstItem || !getEndDate(firstItem)?.isAfter(dayjs())) return <></>;

  return (
    <div className={`${className || ""}`}>
      <div>
        <Trans
          i18nKey="busyUntil"
          ns="expert"
          components={[
            <Countdown
              date={dayjs(firstItem.startedAt).add(firstItem.metadata.maxDuration, "second").toDate()}
              renderer={renderCountDown}
            />,
          ]}
        />
      </div>
    </div>
  );
};

export default ExpertBusyDuration;
